import Dashboard from "views/pages/dashboards/Dashboard";
import AllUsers from "views/pages/users/AllUsers";
import AllListings from "views/pages/listing/AllListings";
import AllOrders from "views/pages/orders/AllOrders";
import AllSupportTickets from "views/pages/support-tickets/AllSupportTickets";
import AllBroadCasts from "views/pages/broadcasts/AllBroadCasts";
import AllPromoCodes from "views/pages/promo-codes/AllPromoCodes";
import Messages from "views/pages/messages/index";
import RolesTable from "views/pages/Role/RolesTable";
import ModerationDashboard from "views/pages/moderation/ModerationDashboard";
import VerificationQueue from "views/pages/moderation/VerificationQueue";
import BehavioralQueue from "views/pages/moderation/BehavioralQueue";
import AppealsQueue from "views/pages/moderation/AppealsQueue";
import AdminAction from "views/pages/notes/index";
import FailedLogin from "views/pages/login/FailedLogin";
import NotificationTemplates from "views/pages/NotificationTemplates";
import "assets/css/custom.css";

const routes = [
  {
    path: "/dashboard",
    name: "sideNav.dashboard",
    permissionKey: "dashboard",
    icon: "ni ni-tv-2",
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/users",
    name: "sideNav.users",
    permissionKey: "users",
    icon: "ni ni-single-02",
    component: <AllUsers />,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "sideNav.listingsAndDeliveries",
    permissionKey: "listingsAndDeliveries",
    icon: "ni ni-align-left-2 text-default",
    state: "tablesCollapse",
    views: [
      {
        path: "/all-listings",
        name: "sideNav.adminListings",
        permissionKey: "listings",
        miniName: "",
        component: <AllListings />,
        layout: "/admin",
      },
      {
        path: "/all-orders",
        name: "sideNav.orders",
        permissionKey: "orders",
        miniName: "",
        component: <AllOrders />,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/support-tickets",
    name: "sideNav.supportTickets",
    permissionKey: "supportTickets",
    icon: "ni ni-support-16",
    component: <AllSupportTickets />,
    layout: "/admin",
  },
  {
    path: "/broadcasts",
    name: "sideNav.broadCasts",
    permissionKey: "broadCasts",
    icon: "ni ni-send",
    component: <AllBroadCasts />,
    layout: "/admin",
  },
  {
    path: "/promo-codes",
    name: "sideNav.promoCodes",
    permissionKey: "promoCodes",
    icon: "ni ni-tag",
    component: <AllPromoCodes />,
    layout: "/admin",
  },
  {
    path: "/messages",
    name: "sideNav.messages",
    permissionKey: "messages",
    icon: "ni ni-chat-round",
    component: <Messages />,
    layout: "/admin",
  },
  {
    path: "/role",
    name: "sideNav.role",
    permissionKey: "rolePage",
    icon: "ni ni-badge",
    component: <RolesTable />,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "sideNav.moderation",
    permissionKey: "flagged",
    icon: "fas fa-user-shield",
    state: "moderationCollapse",
    views: [
      {
        path: "/moderation",
        name: "sideNav.moderationDashboard",
        permissionKey: "flagged",
        miniName: "MD",
        component: <ModerationDashboard />,
        layout: "/admin",
      },
      {
        path: "/moderation/verification",
        name: "sideNav.verificationQueue",
        permissionKey: "flagged",
        miniName: "VQ",
        component: <VerificationQueue />,
        layout: "/admin",
      },
      {
        path: "/moderation/behavioral",
        name: "sideNav.behavioralQueue",
        permissionKey: "flagged",
        miniName: "BQ",
        component: <BehavioralQueue />,
        layout: "/admin",
      },
      {
        path: "/moderation/appeals",
        name: "sideNav.appealsQueue",
        permissionKey: "flagged",
        miniName: "AQ",
        component: <AppealsQueue />,
        layout: "/admin",
      },
    ],
  },
  {
    collapse: true,
    name: "sideNav.auditAndSecurity",
    permissionKey: "auditAndSecurity",
    icon: "ni ni-lock-circle-open",
    state: "auditCollapse",
    views: [
      {
        path: "/admin-action",
        name: "sideNav.adminAction",
        permissionKey: "adminAction",
        miniName: "",
        component: <AdminAction />,
        layout: "/admin",
      },
      {
        path: "/failedLogin",
        name: "sideNav.failedLogin",
        permissionKey: "failedLogin",
        miniName: "",
        component: <FailedLogin />,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/notification-templates",
    name: "sideNav.notificationTemplate",
    permissionKey: "notificationTemplate",
    icon: "ni ni-collection",
    component: <NotificationTemplates />,
    layout: "/admin",
  },
];

export default routes;
